import { Injectable } from '@angular/core';
import { SimpleCardAnswers, SimpleExerciseAnswer, SimpleQuestionAnswer } from '@df/models/answer-question';

@Injectable({
    providedIn: 'root'
})
export class QuestionService {
    public cardAnswers: Array<SimpleCardAnswers> = [];
    public exerciseAnswers: Array<SimpleExerciseAnswer> = [];
    public questionAnswers: Array<SimpleQuestionAnswer> = [];

    constructor() {}

    public setQuestionAnswer(question_id: number, short_answer: string): void {
        const questionAnswer = new SimpleQuestionAnswer(question_id, short_answer);
        this.questionAnswers.push(questionAnswer);
    }

    public getQuestionAnswer(question_id: number): SimpleQuestionAnswer {
        for (const answ of this.questionAnswers) {
            if (question_id === answ.question) {
                return answ;
            }
        }
    }

    public setExerciseAnswer(exercise_id: number, questionAnswer: SimpleQuestionAnswer): void {
        const exerciseAnswer = new SimpleExerciseAnswer(exercise_id, questionAnswer);
        this.exerciseAnswers.push(exerciseAnswer);
    }

    public getExerciseAnswer(exercise_id: number): SimpleExerciseAnswer {
        for (const answ of this.exerciseAnswers) {
            if (exercise_id === answ.exercise) {
                return answ;
            }
        }
    }
}
